import { drawRoundedPolygon, fitToSize, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    horizontalInsetRatio: 1 / 6
};
/**
 * A visual element that renders a preparation symbol with hexagonal shape.
 * Extends Rectangle and provides functionality for creating preparation/setup process shapes.
 */
export class Preparation extends Rectangle {
    /**
     * Creates a new Preparation instance.
     * @param options Configuration options for the preparation shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /** @hidden */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const xOffset = width * this.options.horizontalInsetRatio;
        const points = [
            { x: xOffset, y: 0 },
            { x: width - xOffset, y: 0 },
            { x: width, y: height / 2 },
            { x: width - xOffset, y: height },
            { x: xOffset, y: height },
            { x: 0, y: height / 2 }
        ];
        drawRoundedPolygon(drawingElement, points, this.options.cornerRadius);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
